import type { CreativePreview } from '@/features/campaigns/types/campaign';
import type { PreviewDeviceKind } from './constants';
import { ExactScreenFrame } from './ExactScreenFrame';

type PhysicalScreenPreviewProps = {
  device: PreviewDeviceKind;
  creative?: CreativePreview;
  detecting?: boolean;
  objectFit?: 'contain' | 'cover';
};

/**
 * Physical Screenista product preview — landscape & portrait chassis only.
 */
export function PhysicalScreenPreview({
  device,
  creative,
  detecting = false,
  objectFit = 'contain',
}: PhysicalScreenPreviewProps) {
  return (
    <div className="relative flex h-full max-h-full w-full min-h-0 items-center justify-center overflow-hidden">
      <ExactScreenFrame
        device={device}
        creative={creative}
        detecting={detecting}
        objectFit={objectFit}
      />
    </div>
  );
}
